import type { FetchTruckModelsListQuery } from '@/features/truck-models/api'
import type { TruckModelsSearch } from '@/routes/_protected/$tenantKey/settings/truck-models/-models'

export function buildFetchTruckModelsQuery(
  tenantKey: string,
  deps: TruckModelsSearch
): FetchTruckModelsListQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
